import { atomWithLocalStorage } from "./atom-with-storage";

export const sideBarAtom = atomWithLocalStorage("atom.sideBar", {
  expanded: true,
});

export const sideBarMoreAtom = atomWithLocalStorage("atom.sideBarMore", {
  expanded: true,
});
